import React, { useState, useEffect, useRef } from "react";
import CategoryDropdown from "../Layouts/CategoryDropdown";
import CompanyDropdown from "../Layouts/CompanyDropdown";
import { Delete, Edit } from "@mui/icons-material";
import {
  IconButton,
  Modal,
  Button,
  Box,
  Typography,
  Paper,
  Divider,
  Dialog,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Popup from "../Layouts/Popup/Popup";
import axios from "axios";
import CommonDelete from "../CommonActions/CommonDelete";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { AllapprovalCompanysDetails } from "../../redux/action/Company&User/ApprovalCompanys";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/system";
import PageLoader from "../CommonActions/PageLoader";
import { GetTokenFunc } from "../../utils/GetToken";
import { useGetcreditrequests } from "./Hooks";
import GetBalanceComp from "./GetComapnyBalance";
import LastPurchaseDate from "./LastPurchaseDate";
import LastSellDate from "./LastSellDate";
import { useCategories } from "../../Hooks/useCategories";

const recyclebin = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Recyclebin/recyclebin.png';


export let Category = "";
export let CompanyStatus = "";
export let Membership = "";
export let Page = "";
export let SelectedCompany = "";
export let DateFilter = "";

const CompanyListingApprovals = () => {
  const { categoryOptions } = useCategories();
  const StyledPagination = styled(Pagination)({
    "& .MuiPaginationItem-root": {
      color: "#1976d2",
    },
    "& .MuiPaginationItem-root.Mui-selected": {
      color: "#fff",
    },
    "& .MuiPagination-ul li:last-child": {
      marginLeft: "16px",
    },
    "& .css-1v2lvtn-MuiPaginationItem-root": {
      marginRight: "16px",
      border: "none !important",
    },
    "& .MuiPagination-ul li:last-child": {
      marginLeft: "16px",
    },
    "& .MuiPagination-ul li:last-child button::before": {
      content: "'Last'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginRight: "8px",
    },
    "& .MuiPagination-ul li:first-child": {
      marginRight: "16px",
    },
    "& .MuiPagination-ul li:last-child button::before": {
      content: "'Last'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginRight: "8px",
    },
    "& .MuiPagination-ul li:first-child": {
      marginRight: "16px",
    },
    "& .MuiPagination-ul li:first-child button::after": {
      content: "'First'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginLeft: "8px",
    },
    "& .MuiPaginationItem-icon": {
      color: "#445FD2",
      fontWeight: 800,
    },
  });

  const [id, setId] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [activeTab, setActiveTab] = useState(2);
  const [content, setContent] = useState("");
  const [companies, setCompanies] = useState();
  const [companystatus, setCompanystatus] = useState("");
  const [membership, setMembership] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // --- MFA (email OTP) gate for company deletion ---
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpMaskedEmail, setOtpMaskedEmail] = useState("");
  const [otpResendIn, setOtpResendIn] = useState(0);
  const deleteCompanyIdRef = useRef("");
  const otpVerifyingRef = useRef(false);
  const [AllCompanyName, setAllCompanyName] = useState();
  const [selectedCompany, setSelectedCompany] = useState("");
  const [date, setDate] = useState("");
  const [totalProducts, setTotalProducts] = useState([]);
  const [totalMembers, setTotalMembers] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [initialPaginationCount, setInitialPaginationCount] = useState(
    currentPage || 1
  );

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const {
    data: requestData,
    isLoading: ApprovalDataLoading,
    isError: ApprovalDataError,
    refetch: ApprovalDataRefetch,
  } = useGetcreditrequests();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCompany, loading } = useSelector((state) => state.AllCompany);
  useEffect(() => {
    if (AllCompany && AllCompany?.finalCount !== undefined) {
      setInitialPaginationCount(AllCompany?.finalCount);
    }
  }, [AllCompany?.finalCount]);

  Category = category;
  CompanyStatus = companystatus;
  Membership = membership;
  Page = currentPage;
  SelectedCompany = selectedCompany;
  DateFilter = date;

  // Step 1: ask the backend to email a one-time code to the acting admin.
  const requestDeleteOtp = async ({ resend = false } = {}) => {
    const companyId = deleteCompanyIdRef.current || (id ? String(id) : "");
    if (!companyId) return;
    setOtpSending(true);
    try {
      const res = await axios.post(
        `/api/v1/admin/RequestCompanyDeleteOtp/${companyId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      setOtpMaskedEmail(res?.data?.maskedEmail || "");
      setOtpModalOpen(true);
      setOtpResendIn(30);
      toast.success(
        resend
          ? "A new verification code has been sent to your email."
          : res?.data?.message || "Verification code sent to your email."
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Could not send the verification code. Please try again."
      );
    } finally {
      setOtpSending(false);
    }
  };

  // Step 2: submit the code; the company is deleted only if the backend verifies it.
  const confirmDeleteWithOtp = async () => {
    if (otpVerifyingRef.current) return;
    const companyId = deleteCompanyIdRef.current || (id ? String(id) : "");
    const code = String(otpValue || "").trim();
    if (!companyId) {
      toast.error("Company not selected. Please try again.");
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      toast.error("Enter the 6-digit code sent to your email.");
      return;
    }
    otpVerifyingRef.current = true;
    setOtpVerifying(true);
    try {
      await axios.post(
        `/api/v1/admin/DeleteCompanyById/${companyId}`,
        { otp: code },
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Company deleted successfully.");
      setOtpModalOpen(false);
      setOtpValue("");
      setOtpMaskedEmail("");
      deleteCompanyIdRef.current = "";
      dispatch(
        AllapprovalCompanysDetails(
          category,
          companystatus,
          membership,
          currentPage
        )
      );
    } catch (err) {
      const data = err?.response?.data || {};
      const remaining =
        typeof data.remainingAttempts === "number"
          ? ` ${data.remainingAttempts} attempt(s) left.`
          : "";
      toast.error((data.message || "Verification failed.") + remaining);
      if (err?.response?.status === 403) {
        setOtpModalOpen(false);
        setOtpValue("");
      }
    } finally {
      otpVerifyingRef.current = false;
      setOtpVerifying(false);
    }
  };

  useEffect(() => {
    dispatch(
      AllapprovalCompanysDetails(
        category,
        companystatus,
        membership,
        currentPage
      )
    );
  }, [
    dispatch,
    category,
    companystatus,
    membership,
    selectedCompany,
    date,
    currentPage,
  ]);

  const filterByCompany = async () => {
    await axios
      .get(`product/get_allproducts_bycompany`, { withCredentials: true })
      .then((res) => {
        setAllCompanyName(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    filterByCompany();
  }, []);

  const handleDelete = () => {
    // Don't delete on confirm — first require an emailed OTP (MFA).
    setIsDeleteModalOpen(false);
    requestDeleteOtp();
  };

  const handleClose = () => {
    setIsDeleteModalOpen(false);
  };

  // Countdown that re-enables the "Resend code" action.
  useEffect(() => {
    if (otpResendIn <= 0) return;
    const t = setTimeout(() => setOtpResendIn((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [otpResendIn]);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleEditButtonClick = (id) => {
    navigate(`/admindashboard/allproductapprovals/${id}`);
  };

  const handleCompanyChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCompany(selectedValue);
  };

  const GetAllTotalProductsCount = async () => {
    await axios
      .get(`/api/v1/admin/GetAllTotalProductsCount`, {
        headers: {
          authorization: `Bearer ${GetTokenFunc()}`,
        },
      })
      .then((res) => {
        setTotalProducts(res.data);
      })
      .catch((err) => {});
  };

  const GetAllTotalUserCount = async () => {
    await axios
      .get(`/api/v1/admin/GetAllTotalUserCount`, {
        headers: {
          authorization: `Bearer ${GetTokenFunc()}`,
        },
      })
      .then((res) => {
        setTotalMembers(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    GetAllTotalProductsCount();
    GetAllTotalUserCount();
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        justifyContent: "flex-end",
        minHeight: 600,
        width: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            lg: "repeat(5, minmax(0, 1fr))",
          },
          columnGap: 2,
          rowGap: 2.5,
          p: 2,
          pb: 2.5,
          alignItems: "end",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}>
          <Typography sx={filterLabelStyle}>Select Category</Typography>
          <Box
            component="select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            sx={filterSelectSx}
          >
            <option value="">All</option>
            {categoryOptions?.filter((o) => o.value).map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}>
          <Typography sx={filterLabelStyle}>Select Member</Typography>
          <Box
            component="select"
            onChange={handleCompanyChange}
            value={selectedCompany}
            sx={filterSelectSx}
          >
            <option value="">All</option>
            {AllCompanyName?.map((name, index) => (
              <option key={index} value={name?.companyName}>
                {name?.companyName}
              </option>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}>
          <Typography sx={filterLabelStyle}>Status</Typography>
          <Box
            component="select"
            value={companystatus}
            onChange={(e) => setCompanystatus(e.target.value)}
            sx={filterSelectSx}
          >
            <option value="">All</option>
            <option value="EMAIL">Email Verification</option>
            <option value="GST">GST Details</option>
            <option value="BANK_DETAILS">Pan Details</option>
            <option value="TNC">T&amp;C</option>
            <option value="PAYMENT">Membership Plans</option>
            <option value="UNDER_REVIEW">Under Review</option>
            <option value="ONBOARDING_COMPLETE">Onboarding Complete</option>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}>
          <Typography sx={filterLabelStyle}>Membership</Typography>
          <Box
            component="select"
            value={membership}
            onChange={(e) => setMembership(e.target.value)}
            sx={filterSelectSx}
          >
            <option value="">All</option>
            <option value="advance">Advance Plan</option>
            <option value="basic">Standard Plan</option>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}>
          <Typography sx={filterLabelStyle}>Days</Typography>
          <Box
            component="select"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            sx={filterSelectSx}
          >
            <option value="">All</option>
            <option value="7">7 Days</option>
            <option value="15">15 Days</option>
            <option value="30">1 Month</option>
            <option value="90">3 Months</option>
            <option value="180">6 Months</option>
            <option value="360">1 Year</option>
            <option value="1080">3 Years</option>
            <option value="1800">5 Years</option>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ mx: 2 }} />

      <Box sx={{ background: "rgba(250, 251, 252, 1)", p: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Box sx={buddge}>
            <Typography sx={textBudge}>
              {AllCompany instanceof Object
                ? `Total Members : ${AllCompany?.allCompanySCount ?? 0}`
                : "Total Members: 0"}
            </Typography>
          </Box>
        </Box>
        <div>
          {AllCompany?.Companys?.length <= 0 ? (
            <Box sx={setBox}>
              <img
                src={recyclebin}
                alt="recycle"
                style={{ height: "auto", width: "23%" }}
              />
              <Typography sx={empty}>Data is empty</Typography>
            </Box>
          ) : (
            <table className="common-table">
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 5,
                    width: "100%",
                  }}
                >
                  <PageLoader />
                </Box>
              ) : (
                <>
                  <thead>
                    <tr>
                      <td width={"4%"} align="left">
                        No .
                      </td>
                      <td width={"18%"} align="left">
                        Member Name
                      </td>
                      <td width={"10%"}>Status</td>
                      <td width={"10%"}>Total Products</td>
                      <td width={"5%"}>Members</td>
                      <td width={"10%"}>Date</td>
                      <td width={"5%"}>Membership</td>
                      <td width={"10%"}> Purchase</td>
                      <td width={"9%"}>Last Purchase</td>
                      <td width={"10%"}>Sale</td>
                      <td width={"9%"}>Last Sale</td>
                      <td width={"4%"}>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {AllCompany?.Companys?.map((x, i) => {
                      return (
                        <tr>
                          <td className="font-10-600">
                            <span>{i + 1}</span>
                          </td>
                          <td align="left" className="product-title-colum">
                            <img
                              src={x?.CompanyAvatar?.url}
                              alt=""
                              style={{ height: "30px", width: "30px" }}
                            />
                            <Box className="product-title-box">
                              <label>{x?.companyName}</label>
                              <span>Company ID : {x?._id} </span>
                            </Box>
                          </td>
                          {x?.companyOnboardingStatus?.length > 0 ? (
                            <td className="blueText">
                              <label>
                                {x?.companyOnboardingStatus === "BANK_DETAILS"
                                  ? "PAN_DETAILS"
                                  : x?.companyOnboardingStatus}
                              </label>
                              <span>&nbsp;</span>
                            </td>
                          ) : (
                            <td className="blueText">
                              <label>EMAIL_VERIFICATION</label>
                              <span>&nbsp;</span>
                            </td>
                          )}
                          <td className="blueText">
                            <label>
                              {totalProducts
                                .filter(
                                  (product) => product?.company === x?._id
                                )
                                .reduce(
                                  (acc, product) =>
                                    acc + (product.productCount || 0),
                                  0
                                )}
                            </label>
                            <span>&nbsp;</span>
                          </td>

                          <td className="blueText">
                            <label>
                              {totalMembers
                                .filter((member) => member?.company === x?._id)
                                .reduce(
                                  (acc, member) => acc + (member.Users || 0),
                                  0
                                )}
                            </label>
                            <span style={{ width: "10px" }}>&nbsp;</span>
                          </td>
                          <td className="date">
                            {" "}
                            {new Date(
                              x?.memberships?.length > 0
                                ? x?.memberships?.at(-1)?.MembershipStartDate
                                : x?.createdAt
                            ).toLocaleDateString("en-GB", {
                              timeZone: "UTC",
                            })}
                          </td>

                          <td className="font-12-400">
                            {x?.companyOnboardingStatus ===
                            "ONBOARDING_COMPLETE" ? (
                              x?.memberships ? (
                                <>
                                  {x?.memberships[x?.memberships?.length - 1]
                                    ?.Membership === "basic"
                                    ? "Standard"
                                    : x?.memberships[x?.memberships?.length - 1]
                                        ?.Membership === "advance"
                                    ? "Advance"
                                    : x?.ChoosedPlan}{" "}
                                </>
                              ) : null
                            ) : (
                              "--"
                            )}
                          </td>

                          <td className="blueText">
                            <label>
                              <GetBalanceComp id={x?._id} Purchase={true} />
                            </label>
                          </td>

                          <td className="date">
                            <LastPurchaseDate companyId={x?._id} />
                          </td>

                          <td className="blueText">
                            <label>
                              <GetBalanceComp id={x?._id} Sell={true} />
                            </label>
                          </td>

                          <td className="date">
                            <LastSellDate companyId={x?._id} />
                          </td>

                          <td>
                            <Box sx={{ display: "flex" }}>
                              <IconButton
                                aria-label="edit"
                                style={iconStyle}
                                onClick={() => {
                                  handleEditButtonClick(x._id);
                                  setId(x._id);
                                  deleteCompanyIdRef.current = String(x._id);
                                }}
                              >
                                <Edit />
                              </IconButton>
                            </Box>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              )}
            </table>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: {
                xl: "100%",
                lg: "100%",
                md: "100%",
                sm: "100%",
                xs: "100%",
              },
              mx: "auto",
            }}
            mt={2}
          >
            <Stack>
              <StyledPagination
                size="medium"
                count={initialPaginationCount}
                color="primary"
                showFirstButton
                showLastButton
                page={currentPage}
                onChange={handlePageChange}
                strokeWidth={currentPage}
              />
            </Stack>
          </Box>
        </div>
      </Box>
      <Popup
        openPopup={isOpen}
        popupTitle="Edit : Product Details"
        popupContent={content}
        handleClose={() => {
          setIsOpen(false);
        }}
      />
      <CommonDelete
        open={isDeleteModalOpen}
        onClose={handleClose}
        onDelete={handleDelete}
        text="Are you sure you want to delete this Company?"
        ButtonLabel="Delete"
        cancelButtonLabel="Cancel"
      />
      {/* MFA step: a 6-digit code emailed to the admin is required to delete. */}
      <Dialog
        open={otpModalOpen}
        onClose={() => {
          if (!otpVerifying) {
            setOtpModalOpen(false);
            setOtpValue("");
          }
        }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontWeight: 600, fontSize: "16px", mb: 1 }}>
            Verify to delete this company
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#666", mb: 2 }}>
            For security, deleting a company requires a verification code.
            {otpMaskedEmail
              ? ` We emailed a 6-digit code to ${otpMaskedEmail}.`
              : " We emailed a 6-digit code to your registered admin email."}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            value={otpValue}
            onChange={(e) =>
              setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                confirmDeleteWithOtp();
              }
            }}
            placeholder="Enter 6-digit code"
            inputProps={{
              inputMode: "numeric",
              maxLength: 6,
              style: {
                textAlign: "center",
                letterSpacing: "6px",
                fontSize: "20px",
              },
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button
              variant="contained"
              color="error"
              onClick={confirmDeleteWithOtp}
              disabled={otpVerifying || otpValue.length !== 6}
            >
              {otpVerifying ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Verify & Delete"
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOtpModalOpen(false);
                setOtpValue("");
              }}
              disabled={otpVerifying}
            >
              Cancel
            </Button>
          </Box>
          <Button
            size="small"
            onClick={() => requestDeleteOtp({ resend: true })}
            disabled={otpSending || otpResendIn > 0}
            sx={{ mt: 1.5, textTransform: "none" }}
          >
            {otpResendIn > 0
              ? `Resend code in ${otpResendIn}s`
              : otpSending
                ? "Sending..."
                : "Resend code"}
          </Button>
        </Box>
      </Dialog>
    </Paper>
  );
};

export default CompanyListingApprovals;
const iconStyle = {
  color: "rgba(68, 95, 210, 1)",
};

const DeleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  textAlign: "center",
};

const ModalHeaderStyle = {
  color: "#6B7A99",
  fontFamily: "Inter",
  fontSize: 12,
  fontStyle: "normal",
  fontWeight: 600,
  my: 2,
};

const ButtonBoxStyle = {
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "flex-end",
  gap: 1,
  width: "100%",
  bottom: 0,
  height: "100%",
  mt: 2,
};
const ButtonStyle = {
  fontFamily: "poppins",
  fontSize: 10,
  fontWeight: 500,
  border: "0.5px solid rgba(208, 213, 221, 1)",
  width: "140px",
  textTransform: "none",
  borderRadius: 1.5,
};

const filterLabelStyle = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: 1.4,
  color: "#6B7A99",
};

const filterSelectSx = {
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  minHeight: 40,
  px: 1.5,
  py: 1,
  borderRadius: "8px",
  border: "1px solid",
  borderColor: "rgba(224, 224, 224, 1)",
  fontFamily: "Poppins, sans-serif",
  fontSize: "13px",
  color: "rgba(27, 33, 45, 1)",
  bgcolor: "#fff",
  "&:focus": {
    outline: "none",
    borderColor: "rgba(68, 95, 210, 0.6)",
    boxShadow: "0 0 0 2px rgba(68, 95, 210, 0.15)",
  },
};

const empty = {
  color: "#8B8B8B",
  fontFeatureSettings: "clig off, liga off",
  fontFamily: "Poppins",
  fontSize: 16,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  mt: 3,
};
const setBox = {
  background: "#FAFBFC",
  mt: 2,
  height: "auto",
  width: "auto",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "500px",
};

const buddge = {
  display: "flex",
  height: 40,
  padding: 2,
  justifyContent: "center",
  alignItems: "center",
  gap: 5,
  borderRadius: 20,
  background: "var(--White, #FFF)",
};

const textBudge = {
  color: "var(--Grey-Blue-60, #6B7A99)",
  fontFeatureSettings: "clig off, liga off",
  fontFamily: "Poppins",
  fontSize: 12,
  fontStyle: "normal",
  fontWeight: 600,
  // lineHeight: 20,
};
